import { useCallback, useEffect, useState } from "react";
import { AdminHomeMetrics } from "../../components/AdminHome/AdminHomeMetrics";
import { ListForApprve } from "../../components/AdminHome/ListForApprove";
import { HeaderPage } from "../../components/HeaderPage";
import useApi from "../../hooks/useApi"
import { AdminLayout } from "../../layout/AdminLayout"
import { AdminHomeMetric } from "../../types/AdminHomeMetric";


const Home = () => {

    const api = useApi();

    const [metrics,setMetrics] = useState<AdminHomeMetric>({total_city:0,total_diagnoses:0,total_osc:0,total_reply:0})
    const [load,setLoad] = useState<boolean>(false)
    
    const loadDashHome = useCallback(async () => {
        setLoad(true)
        api.get("admin/metrics/home").then(res => {
            setMetrics(res.data)
        }).catch(console.log)
        setLoad(false)
    },[api]) 

    useEffect(()=>{
        loadDashHome()
    },[loadDashHome])



    return (
        <AdminLayout>       
                <HeaderPage name="Geral"/>
                <AdminHomeMetrics metric={metrics} load={load} />  
                <ListForApprve/>   
        </AdminLayout>
    )
}


export default Home
